import React from 'react'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
import ComingSoonBlock from '../../components/ComingSoonBlock'

export default () => {
  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader style={{ marginBottom: 40 }} />
          <ComingSoonBlock />
        </div>
      </div>
      <Footer />
    </>
  )
}
